import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

const ContactInformation = ({email, phone, offices}) =>{
    return(
        <div className="contact--information pl20 pr20">
            <p className="m0 mb40 m-hide">Alternatively, you<br/> can reach us here.</p>
            <div className="contact-info mb40 m-pt20">
                <p className="uppercase m0 bb1 m-b0 pb10 mb20 m-hide">Contact</p>
                <a className="link sainte" href={"mailto:"+email}>{email}</a>
                {phone && <a className="link sainte w-100 inline" href={"tel:"+phone}>{phone}</a>}
            </div>
            {offices?.map((office) => (
                <div className="office mb40" key={office.name}>
                    <div className="ratio-16-9 pos-rel mb20">
                        <GatsbyImage image={office.image} alt={office.name} className="bg-image" />
                    </div>
                    <p className="uppercase m0 bb1 pb10 mb20">{office.name}</p>
                    <div className="flex flex-column">
                        <p className="m0 flex">
                            <span className="uppercase small mr20 lh2">T</span>
                            <a className="link sainte" href={"tel:"+office.phone}>{office.phone}</a>
                        </p>
                        <p className="m0 flex">
                            <span className="uppercase small mr20 lh2">A</span>
                            <a className="link sainte" target="_blank" rel="noreferrer" href={"https://www.google.com/maps/place/"+office.address}>{office.address}</a>
                        </p>
                        <p className="m0 flex">
                            <span className="uppercase small mr20 lh2">M</span>
                            <span className="sainte">{office.mail}</span>
                        </p>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default ContactInformation
